module.exports = __webpack_public_path__ + "img/games-4.7ab15957.jpg";